export default "__VITE_ASSET__Czn14SLk__"